import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthModule } from '@auth0/auth0-angular';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { PageModule } from './page/page.module';
import { PrimeNGModule } from './prime-ng.module';
import { MaskNumberPipe } from './pipes/mask-number.pipe';
import { FindPlanComponent } from './find-plan/find-plan.component';
import { ListItemComponent } from './list-item/list-item.component';
import { EmailConfirmComponent } from './email-confirm/email-confirm.component';
import { LiferayContentComponent } from './liferay-content/liferay-content.component';
import { CostItemComponent } from './cost-item/cost-item.component';
import { SpecialBenefitsComponent } from './special-benefits/special-benefits.component';
import { FormatPhonePipe } from './pipes/format-phone.pipe';
import { FormatPhoneTypePipe } from './pipes/format-phone-type.pipe';
import { CustomToastComponent } from './custom-toast/custom-toast.component';
import { RouterModule } from '@angular/router';
import { PaymentTypeComponent } from './payment-type/payment-type.component';
import { PlanCostComponent } from './plan-cost/plan-cost.component';
import { UpdateBillingComponent } from './update-billing/update-billing.component';
import { CardsModule } from './cards/cards.module';
import { PlanFoundComponent } from './plan-found/plan-found.component';
import { CreditCardInfoComponent } from './credit-card-info/credit-card-info.component';
import { BankAccountInfoComponent } from './bank-account-info/bank-account-info.component';
import { BillingAddressInfoComponent } from './billing-address-info/billing-address-info.component';
import { SharedInputComponent } from './shared-input/shared-input.component';
import { AddPaymentComponent } from './add-payment/add-payment.component';
import { TermsAndConditionsComponent } from './terms-and-conditions/terms-and-conditions.component';
import { PaymentDisplayComponent } from './payment-display/payment-display.component';
import { PaymentConfirmationComponent } from './payment-confirmation/payment-confirmation.component';
import { IconsComponent } from './icons/icons.component';
import { TunnelPageModule } from '../tunnel-page/tunnel-page.module';
import { CapitalizeFirstLetterPipe } from './pipes/capitalize-first.pipe';
import { AddNewCreditCardActionComponent } from './add-new-credit-card-action/add-new-credit-card-action.component';
import { PaymentSummaryComponent } from './payment-summary/payment-summary.component';
import { PaymentDisclaimersAndTermsAndConditionsComponent } from './payment-disclaimers-and-terms-and-conditions/payment-disclaimers-and-terms-and-conditions.component';
import { AddNewBankAccountActionComponent } from './add-new-bank-account-action/add-new-bank-account-action.component';
import { UpdateContactInformationComponent } from './update-contact-information/update-contact-information.component';
import { RecallClaimDialogComponent } from './recall-claim-dialog/recall-claim-dialog.component';
import { GaButtonClickDirective } from '../../directives/ga-button-click.directive';
import { IsPlanFFSDirective } from '../../directives/is-plan-ffs.directive';
import { CreateAccountSharedComponent } from './create-account-shared/create-account-shared.component';
import { CrossSellComponent } from './cross-sell/cross-sell.component';
import { AlertCardComponent } from './alert-card/alert-card.component';
import { FeaturesAndBenefitsComponent } from './features-and-benefits/features-and-benefits.component';
import { RegistrationStepperComponent } from './registration-stepper/registration-stepper.component';
import { ReKeyCardComponent } from './rekey-card/rekey-card.component';
import { MyPlanStoryComponent } from './my-plan-story/my-plan-story.component';

@NgModule({
  declarations: [
    MaskNumberPipe,
    ListItemComponent,
    FindPlanComponent,
    LiferayContentComponent,
    CostItemComponent,
    SpecialBenefitsComponent,
    FormatPhonePipe,
    FormatPhoneTypePipe,
    EmailConfirmComponent,
    CustomToastComponent,
    PaymentTypeComponent,
    PlanCostComponent,
    CustomToastComponent,
    AddPaymentComponent,
    UpdateBillingComponent,
    PlanFoundComponent,
    CreditCardInfoComponent,
    BankAccountInfoComponent,
    BillingAddressInfoComponent,
    SharedInputComponent,
    TermsAndConditionsComponent,
    PaymentDisplayComponent,
    PaymentConfirmationComponent,
    IconsComponent,
    CapitalizeFirstLetterPipe,
    AddNewCreditCardActionComponent,
    AddNewBankAccountActionComponent,
    PaymentSummaryComponent,
    PaymentDisclaimersAndTermsAndConditionsComponent,
    UpdateContactInformationComponent,
    RecallClaimDialogComponent,
    GaButtonClickDirective,
    IsPlanFFSDirective,
    CreateAccountSharedComponent,
    CrossSellComponent,
    AlertCardComponent,
    FeaturesAndBenefitsComponent,
    RegistrationStepperComponent,
    ReKeyCardComponent,
    MyPlanStoryComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    PageModule,
    PrimeNGModule,
    AuthModule,
    RouterModule,
    CardsModule,
    TunnelPageModule,
  ],
  exports: [
    PageModule,
    MaskNumberPipe,
    ListItemComponent,
    FindPlanComponent,
    LiferayContentComponent,
    EmailConfirmComponent,
    LiferayContentComponent,
    CostItemComponent,
    SpecialBenefitsComponent,
    FormatPhonePipe,
    FormatPhoneTypePipe,
    CustomToastComponent,
    PaymentTypeComponent,
    PlanCostComponent,
    PaymentTypeComponent,
    PlanFoundComponent,
    AddPaymentComponent,
    UpdateBillingComponent,
    CreditCardInfoComponent,
    BankAccountInfoComponent,
    BillingAddressInfoComponent,
    SharedInputComponent,
    PlanFoundComponent,
    TermsAndConditionsComponent,
    PaymentDisplayComponent,
    PaymentConfirmationComponent,
    IconsComponent, 
    TunnelPageModule,
    CapitalizeFirstLetterPipe,
    AddNewCreditCardActionComponent,
    AddNewBankAccountActionComponent,
    PaymentSummaryComponent,
    PaymentDisclaimersAndTermsAndConditionsComponent,
    UpdateContactInformationComponent,
    RecallClaimDialogComponent,
    GaButtonClickDirective,
    IsPlanFFSDirective,
    CreateAccountSharedComponent,
    CrossSellComponent,
    AlertCardComponent,
    FeaturesAndBenefitsComponent,
    RegistrationStepperComponent,
    ReKeyCardComponent,
    MyPlanStoryComponent
  ]
})
export class SharedModule { }
